import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=2f2f41ea&scoped=true&"
import script from "./FormatList.vue?vue&type=script&lang=ts&"
export * from "./FormatList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f41ea",
  null
  
)

export default component.exports